<template>
    <div class="row">
        <div class="col-md-12">
            <div class="sales-invoices-toolbar">
                <div class="sales-invoices-toolbar__left">
                    <span>{{ lang('app.rows_per_page_text') }} : </span>
                    <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                        <option value="15">15</option>
                        <option value="30">30</option>
                        <option value="45">45</option>
                        <option value="60">60</option>
                        <option value="90">90</option>
                    </select>
                </div>
                <div class="sales-invoices-toolbar__right">
                    <label class="unbooked-switch" data-testid="unbooked-invoices-switch">
                        <input
                            type="checkbox"
                            v-model="onlyUnbooked"
                        >
                        <span class="unbooked-switch__track" aria-hidden="true"></span>
                        <span class="unbooked-switch__label">{{ uLang('app.only_show_unbooked_invoices') }}</span>
                    </label>
                    <button
                        type="button"
                        class="btn btn-brand btn-sm"
                        data-testid="unbooked-invoices-export"
                        @click="downloadUnbooked"
                    >
                        {{ uLang('app.download_unbooked_invoices') }}
                    </button>
                </div>
            </div>

            <sales-invoices-table
                :rows-per-page="rowsPerPage"
                :only-unbooked="onlyUnbooked"
            />
        </div>
    </div>
</template>

<script>
    import { SalesInvoicesTable } from '~/components/tables'

    export default {
        name: 'SalesInvoicesTab',

        components: {
            SalesInvoicesTable,
        },

        data() {
            return {
                rowsPerPage: "15",
                onlyUnbooked: false,
            }
        },

        methods: {
            downloadUnbooked() {
                window.location.href = route('invoices.sales.unbooked.export');
            },
        },
    }
</script>

<style lang="css" scoped>
.sales-invoices-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px;
}

.sales-invoices-toolbar__right {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
}

.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}

.unbooked-switch {
    display: inline-flex;
    align-items: center;
    margin: 0;
    cursor: pointer;
    font-weight: normal;
}

.unbooked-switch input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.unbooked-switch__track {
    width: 36px;
    height: 20px;
    background: #c5c5c5;
    border-radius: 10px;
    position: relative;
    margin-right: 8px;
    flex-shrink: 0;
}

.unbooked-switch__track::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: transform 0.15s ease;
}

.unbooked-switch input:checked + .unbooked-switch__track {
    background: rgba(92, 71, 139, 1);
}

.unbooked-switch input:checked + .unbooked-switch__track::after {
    transform: translateX(16px);
}

.unbooked-switch input:focus + .unbooked-switch__track {
    box-shadow: 0 0 0 2px rgba(92, 71, 139, 0.35);
}
</style>
